// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__bXDEW","Main_article___topSpacing":"Main_Main_article___topSpacing__I0rZV"};